import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import {
  BoatProduct,
  BoatType,
} from "Store/interfaces/products/checkout/riskProducts/BoatProduct";

import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import React from "react";
import { ProductDetail } from "../../interface";

export const boatDetailList = (
  product: BoatProduct,
  types: any,
  lang: string,
): ProductDetail[] => {
  const details = [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    {
      name: "coverageAmount",
      value: (
        <NumberValue type={VALUE_TYPE.NOK} value={product.coverageAmount} />
      ),
    },
    {
      name: "boatType",
      value: types.boatTypes[product.boatType][lang],
    },
    {
      name: "damageCountRecentYears",
      value: product.damageCountRecentYears,
    },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
    {
      name: "numberOfYearsAsOwner",
      value: types.numberOfYearsAsOwner[product.numberOfYearsAsOwner][lang],
    },
  ];

  if (product.boatType !== BoatType.SMALL_BOAT) {
    details.push(
      {
        name: "lengthInFeet",
        value: (
          <NumberValue
            type={VALUE_TYPE.LENGTH_FEET}
            value={product.lengthInFeet}
          />
        ),
      },
      {
        name: "brandAndModel",
        value: product.brandAndModel,
      },

      {
        name: "modelYear",
        value: product.modelYear,
      },
      {
        name: "harbourZipCode",
        value: product.harbourZipCode,
      },
      {
        name: "harbourSecurity",
        value: <YesOrNo value={product.harbourSecurity ?? false} />,
      },
      {
        name: "trackingSystem",
        value: <YesOrNo value={product.trackingSystem ?? false} />,
      },
      {
        name: "hullAndEngineIdMarked",
        value: <YesOrNo value={product.hullAndEngineIdMarked ?? false} />,
      },
      {
        name: "memberOfRedningsselskapetCoastGuard",
        value: (
          <YesOrNo
            value={product.memberOfRedningsselskapetCoastGuard ?? false}
          />
        ),
      },
      {
        name: "usedByYoungerDriver",
        value: <YesOrNo value={product.usedByYoungerDriver ?? false} />,
      },
    );

    if (
      product.boatType === BoatType.MOTOR_BOAT_INBOARDS ||
      product.boatType === BoatType.MOTOR_BOAT_OUTBOARDS
    ) {
      details.push(
        {
          name: "engineHorsePower",
          value: (
            <NumberValue
              type={VALUE_TYPE.HORSEPOWER}
              value={product.engineHorsePower}
            />
          ),
        },
        {
          name: "engineTopSpeed",
          value: (
            <NumberValue
              type={VALUE_TYPE.SPEED_KNOP}
              value={product.engineTopSpeed}
            />
          ),
        },
      );
    }

    if (product.boatType === BoatType.MOTOR_BOAT_OUTBOARDS) {
      details.push({
        name: "engineBrand",
        value: product.engineBrand,
      });
    }
  }
  return details;
};
